import PropTypes from 'prop-types';
import { Radio } from '@utilities';
import { getOptionLabel } from '../../utilities/helpers';

import PercentInputs from './components/PercentInputs';
import VolumeInputs from './components/VolumeInputs';

import styles from './_index.module.scss';

const PurchaseVolumeOptions = ({
  activePrompt,
  activePromptAnswers,
  onAnswerChange,
  promptKey,
}) => {
  const attributes = activePrompt?.attributes || [];
  const selectedId = Array.isArray(activePromptAnswers) && activePromptAnswers[0]?.attributeId;
  const selectedOption = attributes.find((a) => a.id === selectedId) || null;

  const handleRadioChange = (option) => {
    const newAnswer = {
      attributeId: option.id,
      field: option.id,
      fieldType: 'NUMERIC',
      formattedDisplay: getOptionLabel({ option }),
      operator: 'IN_RANGE',
      promptId: activePrompt.id,
      values: [],
    };
    onAnswerChange([newAnswer]);
  };

  const updateSelectedAnswerValues = (valuesArray) => {
    if (!selectedOption) return;
    const base = {
      attributeId: selectedOption.id,
      field: selectedOption.id,
      fieldType: 'NUMERIC',
      formattedDisplay: getOptionLabel({ option: selectedOption }),
      operator: 'IN_RANGE',
      promptId: activePrompt.id,
      values: valuesArray,
    };
    onAnswerChange([base]);
  };

  return (
    <ul className={styles['purchase-volume-options']}>
      {attributes.map((option, index) => {
        const isChecked = activePromptAnswers?.some((answer) => answer.attributeId === option.id);
        const isPercent = option.id.includes('percent');
        const label = `${getOptionLabel({ option })}${isPercent && isChecked ? ' - Must sum to 100%' : ''}`;

        return (
          <li key={`option-${index}`}>
            <>
              <div className={isChecked ? styles['is-selected'] : ''}>
                <Radio
                  isChecked={isChecked}
                  isInverseColor
                  label={label}
                  name={String(activePrompt?.id)}
                  onChange={() => handleRadioChange(option)}
                  value={option}
                />
              </div>
              {isChecked && (
                <div className={styles['purchase-volume-config']}>
                  {isPercent ? (
                    <PercentInputs
                      onChangeValues={updateSelectedAnswerValues}
                      selectedAnswer={activePromptAnswers?.[0]}
                    />
                  ) : (
                    <VolumeInputs
                      onChangeValues={updateSelectedAnswerValues}
                      purchaseType={promptKey}
                      selectedAnswer={activePromptAnswers?.[0]}
                    />
                  )}
                </div>
              )}
            </>
          </li>
        );
      })}
    </ul>
  );
};

PurchaseVolumeOptions.propTypes = {
  activePrompt: PropTypes.object,
  activePromptAnswers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onAnswerChange: PropTypes.func.isRequired,
  promptKey: PropTypes.string.isRequired,
};

export default PurchaseVolumeOptions;
